class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    window.pincode = localStorage.getItem('locationID');
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    var dataurl = '';
    if(this.dataset.url.includes('?')) {
      dataurl = `${this.dataset.url}&location=${pincode}L`;
    }else {
      dataurl = `${this.dataset.url}?location-${pincode}L`;
    }
    fetch(dataurl)
      .then(response => response.text())
      .then(text => {
        
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
